import { useTranslation } from 'react-i18next';

export type ClassFilter = 'past' | 'upcoming' | 'all';

interface ClassFilterToggleProps {
  value: ClassFilter;
  onChange: (next: ClassFilter) => void;
  counts: { past: number; upcoming: number; all: number };
}

const FILTERS: ClassFilter[] = ['past', 'upcoming', 'all'];

export function ClassFilterToggle({ value, onChange, counts }: ClassFilterToggleProps) {
  const { t } = useTranslation('admin');

  return (
    <div
      role="radiogroup"
      aria-label={t('p2e.classes.page.title')}
      className="inline-flex w-fit items-center gap-1 rounded-full border border-rose-200 bg-white p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.8),0_2px_0_rgba(0,0,0,0.04),0_4px_8px_rgba(247,141,167,0.08)]"
    >
      {FILTERS.map((filter) => {
        const isActive = value === filter;
        const count = counts[filter];
        return (
          <button
            key={filter}
            type="button"
            role="radio"
            aria-checked={isActive}
            onClick={() => onChange(filter)}
            className={
              'inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-all duration-100 ease-out outline-none focus-visible:ring-2 focus-visible:ring-rose-300 ' +
              (isActive
                ? 'bg-gradient-to-b from-[#e04545] to-[#cf2e2e] text-white border border-[#cf2e2e]/60 border-b-[3px] border-b-[#a82424] shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_2px_0_rgba(0,0,0,0.15)] hover:translate-y-[1px] active:translate-y-[2px]'
                : 'text-gray-600 hover:text-[#cf2e2e]')
            }
          >
            <span>{t(`p2e.classes.page.filter.${filter}`)}</span>
            <span
              className={
                'inline-flex min-w-[1.5rem] items-center justify-center rounded-full px-1.5 py-0.5 text-xs tabular-nums ' +
                (isActive ? 'bg-white/25 text-white' : 'bg-rose-50 text-[#cf2e2e]')
              }
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
